import { gql } from '@apollo/client';

export const RESOLVE_CLASH = gql`
    mutation ResolveBestPracticeClash($input: ResolveBestPracticeClashInput!) {
        resolveBestPracticeClash(input: $input) {
            id
            isResolved
            resolvedDate
            resolvedBy
        }
    }
`;
